import { render, staticRenderFns } from "./acessoNegado.vue?vue&type=template&id=7fc81838&scoped=true&"
import script from "./acessoNegado.vue?vue&type=script&lang=js&"
export * from "./acessoNegado.vue?vue&type=script&lang=js&"
import style0 from "./acessoNegado.vue?vue&type=style&index=0&id=7fc81838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc81838",
  null
  
)

export default component.exports